import { logUtil } from 'packages/src'

export default function setItemLocalStorageUtil (key, value) {
  const logPrefix = `key=${key}`
  logUtil('setItemLocalStorageUtil').debug(`${logPrefix} [start] value=`, value)
  if (!window.localStorage) {
    logUtil('setItemLocalStorageUtil').debug(`${logPrefix} [noop] no localStorage`)
    return
  }
  return window.localStorage.setItem(key, value)
}
